module.exports = __webpack_public_path__ + "static/media/refer_and_earn_selected.b725be9d.svg";